module.exports = __webpack_public_path__ + "assets/images/wallpaper.554d8dc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./imgs/wallpaper.jpg
// module id = 168
// module chunks = 0